export enum Role {
  unknown = 0,
  user = 1000,
  tenant = 2000,
  admin = 3000,
}
